import moment from "moment";
import { clone } from "../../utils";

export function castInvoiceFromDb(invoice){
    let clonedInvoice = clone(invoice);
    clonedInvoice.date_invoice = moment(clonedInvoice.date_invoice);
    clonedInvoice.date_due = moment(clonedInvoice.date_due);
    return invoice;
}

export function adaptInvoiceForMyOpen(invoice) {
    let newInvoice = clone(invoice);
    newInvoice.date_invoice = moment(newInvoice.date_invoice);
    newInvoice.date_due = moment(newInvoice.date_due);
    return newInvoice;
}

export function adaptInvoiceForOpenERP(invoice) {
    invoice = clone(invoice);
    
    return invoice;
}
